import { Dialog, DialogButton, DialogDescription, DialogRoot, DialogTitle } from '~/components/ui/Dialog';
import type { ReactNode } from 'react';

interface ConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: ReactNode;
  isProcessing?: boolean;
  confirmButtonText?: string;
  confirmButtonProcessingText?: string;
  cancelButtonText?: string;
  confirmButtonType?: 'primary' | 'secondary' | 'danger';
}

export function ConfirmationDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  isProcessing = false,
  description,
  confirmButtonText = 'Confirm',
  cancelButtonText = 'Cancel',
  confirmButtonType = 'danger',
  confirmButtonProcessingText = 'Processing...',
}: ConfirmationDialogProps) {
  if (!isOpen) {
    return null;
  }

  return (
    <DialogRoot open={isOpen}>
      <Dialog onBackdrop={onClose} onClose={onClose}>
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription asChild>
          <div>{typeof description === 'string' ? <p>{description}</p> : description}</div>
        </DialogDescription>
        <div className="px-5 pb-4 bg-dualite-background-tertiary flex gap-2 justify-end">
          <DialogButton type="secondary" onClick={onClose}>
            {cancelButtonText}
          </DialogButton>
          <DialogButton
            type="primary"
            onClick={() => {
              onConfirm();
            }}
          >
            {isProcessing ? confirmButtonProcessingText : confirmButtonText}
          </DialogButton>
        </div>
      </Dialog>
    </DialogRoot>
  );
}
